<template>
	<div class="card">
		<slot />
	</div>
</template>

<script>
export default {
	name: 'Card',
}
</script>

<style lang="scss" scoped>
@import '~scss/vars';
@import '~scss/layout';
@import '~scss/mq';

.card {
	@include truncate-margin;

	padding: 1rem;
	background-color: $white;
	box-shadow: 0 0.1875rem 0.375rem 0 rgba($black, 0.15);

	@include mq(md) {
		padding: 3rem;
	}
}
</style>
